import { weekDaysEnum } from 'views/timesheet/consts';

export const defaultTimesheetDaysSettings = {
  isWeekOpen: false,
  timesheetSettingDays: weekDaysEnum.map((day) => ({
    weekDay: day,
    isOpen: false
  }))
};
